/**
 * ---------------------------------------------------------------------------------------------------------------------
 * CART FEATURES — 5 Norte
 * ---------------------------------------------------------------------------------------------------------------------
 *
 * Da vida a las tres funciones agregadas al cart drawer:
 *
 *   1. Contador de reserva regresivo, persistente en sessionStorage.
 *   2. Barra de progreso de envio gratis (el texto lo sigue manejando el custom element nativo).
 *   3. Carga de las recomendaciones IA del upsell.
 *
 * Se carga desde layout/theme.liquid y NO desde los snippets: el cart drawer se vuelve a renderizar
 * entero en cada cambio del carrito, asi que el script tiene que estar siempre presente y volver a
 * enganchar los nodos nuevos a traves de un MutationObserver.
 */

(function () {
  'use strict';

  var RESERVE_STORAGE_KEY = 'cartReserveTimerEnd';

  /* ------------------------------------------------------------------------------------------------
   * 1. Contador de reserva
   * ---------------------------------------------------------------------------------------------- */

  var reserveInterval = null;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function readReserveEnd(minutes) {
    var stored = null;

    try {
      stored = window.sessionStorage.getItem(RESERVE_STORAGE_KEY);
    } catch (error) {
      stored = null;
    }

    var end = stored ? parseInt(stored, 10) : NaN;

    if (isNaN(end) || end <= Date.now()) {
      end = Date.now() + minutes * 60 * 1000;

      try {
        window.sessionStorage.setItem(RESERVE_STORAGE_KEY, String(end));
      } catch (error) {
        /* sessionStorage bloqueado: el contador igual funciona, solo que no persiste */
      }
    }

    return end;
  }

  function tickReserveTimers() {
    var nodes = document.querySelectorAll('[data-cart-reserve-timer]');

    if (nodes.length === 0) {
      if (reserveInterval) {
        window.clearInterval(reserveInterval);
        reserveInterval = null;
      }

      return;
    }

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var minutes = parseInt(node.getAttribute('data-minutes'), 10) || 10;
      var end = readReserveEnd(minutes);
      var remaining = Math.max(0, Math.round((end - Date.now()) / 1000));

      /* Al llegar a cero se reinicia, para no dejar un 00:00 congelado */
      if (remaining <= 0) {
        try {
          window.sessionStorage.removeItem(RESERVE_STORAGE_KEY);
        } catch (error) {
          /* no-op */
        }

        end = readReserveEnd(minutes);
        remaining = Math.max(0, Math.round((end - Date.now()) / 1000));
      }

      var formatted = pad(Math.floor(remaining / 60)) + ':' + pad(remaining % 60);
      var target = node.querySelector('[data-cart-reserve-timer-text]');

      if (target) {
        target.textContent = (node.getAttribute('data-text') || '{time}').replace('{time}', formatted);
      }
    }
  }

  function initReserveTimers() {
    if (document.querySelector('[data-cart-reserve-timer]') === null) {
      return;
    }

    tickReserveTimers();

    if (!reserveInterval) {
      reserveInterval = window.setInterval(tickReserveTimers, 1000);
    }
  }

  /* ------------------------------------------------------------------------------------------------
   * 2. Barra de progreso de envio gratis
   * ---------------------------------------------------------------------------------------------- */

  function updateShippingBar(wrapper) {
    var threshold = parseFloat(wrapper.getAttribute('data-threshold'));
    var bar = wrapper.querySelector('free-shipping-bar');
    var fill = wrapper.querySelector('[data-cart-shipping-bar-fill]');

    if (!bar || !fill || !threshold || threshold <= 0) {
      return;
    }

    var totalPrice = parseFloat(bar.getAttribute('total-price')) || 0;
    var progress = Math.max(0, Math.min(100, (totalPrice / threshold) * 100));

    fill.style.width = progress + '%';
    wrapper.classList.toggle('cart-shipping-bar--reached', progress >= 100);

    var track = wrapper.querySelector('.cart-shipping-bar__track');

    if (track) {
      track.setAttribute('aria-valuenow', String(Math.round(progress)));
    }
  }

  function initShippingBar(wrapper) {
    if (wrapper.getAttribute('data-cart-features-ready') === '1') {
      return;
    }

    wrapper.setAttribute('data-cart-features-ready', '1');

    var bar = wrapper.querySelector('free-shipping-bar');

    if (bar) {
      /* El custom element nativo actualiza total-price en cada cart:change */
      new MutationObserver(function () {
        updateShippingBar(wrapper);
      }).observe(bar, { attributes: true, attributeFilter: ['total-price'] });
    }

    updateShippingBar(wrapper);
  }

  /* ------------------------------------------------------------------------------------------------
   * 3. Upsell con recomendaciones IA
   * ---------------------------------------------------------------------------------------------- */

  function loadAiUpsell(node) {
    if (node.getAttribute('data-cart-features-ready') === '1') {
      return;
    }

    node.setAttribute('data-cart-features-ready', '1');

    var url = node.getAttribute('data-url');

    if (!url) {
      node.remove();
      return;
    }

    fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (!html || !html.trim()) {
          node.remove();
          return;
        }

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var section = parsed.getElementById('shopify-section-cart-upsell-ai');
        var markup = section ? section.innerHTML : '';

        if (!markup.trim()) {
          node.remove();
          return;
        }

        /* createContextualFragment (y no innerHTML) para que los custom elements del tema se activen */
        node.replaceWith(document.createRange().createContextualFragment(markup));
      })
      .catch(function () {
        node.remove();
      });
  }

  /* ------------------------------------------------------------------------------------------------
   * Escaneo y re-enganche
   * ---------------------------------------------------------------------------------------------- */

  var scanScheduled = false;

  function scan() {
    scanScheduled = false;

    initReserveTimers();

    var bars = document.querySelectorAll('[data-cart-shipping-bar]:not([data-cart-features-ready="1"])');

    for (var i = 0; i < bars.length; i++) {
      initShippingBar(bars[i]);
    }

    var aiNodes = document.querySelectorAll('[data-cart-upsell-ai]:not([data-cart-features-ready="1"])');

    for (var j = 0; j < aiNodes.length; j++) {
      loadAiUpsell(aiNodes[j]);
    }
  }

  function scheduleScan() {
    if (scanScheduled) {
      return;
    }

    scanScheduled = true;
    window.requestAnimationFrame(scan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  if (!window.__cartFeaturesObserver) {
    window.__cartFeaturesObserver = new MutationObserver(scheduleScan);
    window.__cartFeaturesObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('cart:change', scheduleScan);
})();
